'use client';
import { IC_ALCOHOL, IC_BREASTFEEDING, IC_DRIVING, IC_KIDNEY, IC_LIVER, IC_PREGNANCY } from '@/assets/icons';
import ReadMore from '@/components/molecules/read-more';
import { isEmpty } from 'lodash';
import { useSearchParams } from 'next/navigation';
import { ProductSwitcher } from './ProductSwitcher';

const ProductSafetyAdvices = ({ data, name, product, p_forms, translationBn }: any) => {
	const search = useSearchParams();
	const getLanguage = search.get('lang');

	const getColor = (type: string) => {
		const colorMap: { [key: string]: string } = {
			Alcohol: 'bg-error',
			Pregnancy: 'bg-warning200',
			Breastfeeding: 'bg-warning200',
			Driving: 'bg-primary',
			Kidney: 'bg-orange',
			Liver: 'bg-orange'
		};
		return colorMap[type] || 'bg-red';
	};

	const getImage = (type: string) => {
		const iconMap: { [key: string]: JSX.Element } = {
			Alcohol: <IC_ALCOHOL />,
			Pregnancy: <IC_PREGNANCY />,
			Breastfeeding: <IC_BREASTFEEDING />,
			Driving: <IC_DRIVING />,
			Kidney: <IC_KIDNEY />,
			Liver: <IC_LIVER />
		};
		return iconMap[type] || null;
	};

	// Tag component
	const Tag = ({ item }: any) => (
		<div
			className={`${getColor(item.type)} px-10 py-5 rounded-5 text-white text-16 fw-400`}
			style={{ width: 'fit-content' }}>
			{item.tag}
		</div>
	);

	const { p_description } = product;

	let safety_advices = [];
	if (getLanguage === 'bn') {
		safety_advices = p_description?.generic?.g_safety_advices_bn || [];
	} else {
		safety_advices = p_description?.generic?.safety_advices || [];
	}

	if (!Array.isArray(safety_advices) || isEmpty(safety_advices)) {
		return null;
	}

	const filteredSafetyAdvices = safety_advices.filter((item: any) => !isEmpty(item.tag));

	const renderContent = (itemContent: string, name: string, strength: string, form: string, translationBn: any) => {
		const processedContent = itemContent
			.replace(/__NAME__/gi, translationBn?.bn?.p_name || name)
			.replace(/__STRENGTH__/gi, translationBn?.bn?.p_strength || strength)
			.replace(/__FORM__/gi, form);
		return processedContent;
	};

	// JSX rendering
	return (
		<div
			className='bg-white rounded-10 border-1-grey300'
			style={{
				position: 'relative',
				overflow: 'hidden',
				width: '100%'
			}}>
			<div className='d-flex justify-space-between border-b1-grey300 p-20'>
				<div className='text-18 text-grey900 fw-600'>Safety Advices</div>
				{data?.g_brief_description_bn && <ProductSwitcher />}
			</div>
			<div className='d-flex flex-column p-20'>
				{filteredSafetyAdvices.map((item: any, index: number) => {
					const content = renderContent(
						item.content,
						product?.p_name,
						product?.p_strength,
						product?.p_form,
						translationBn
					);

					if (isEmpty(content)) return null;

					return (
						<div key={index} className='mb-20'>
							<div className='d-flex'>
								<div className='mr-20'>{getImage(item.type)}</div>
								<div
									className='py-5'
									style={{
										width: 'calc(100% - 100px)'
									}}>
									{item?.tag && <Tag item={item} />}
									<ReadMore word={100} className='mt-10 text-14 text-grey700 fw-400'>
										{content}
									</ReadMore>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ProductSafetyAdvices;
